import './AppHeader.css';

function AppHeader() {
  return (
    <header className="app-header">
      <h3 className="app-header-logo">
        Hair Life
      </h3>
    </header>
  );
}

export default AppHeader;